module.exports = __webpack_public_path__ + "static/IMG_1398-954fe3c2d647fdcdb3cc5511c7a0e8f1.jpg";